import {
  CreatePickupRequest,
  PickupRequestDetails,
  PickupRequestFormValues,
  PickupRequestPriorityId,
  UpdatePickupRequest,
} from "../../../types";
import { toPickupRequestPriorityId } from "../../../helpers/pickupRequestStatus";

export interface PickupRequestReasonsSelection {
  reasonIds: number[];
  otherReasonText: string;
}

// values.priority already carries the numeric PickupRequestPriorityId — the priority
// SelectInput binds its options' value straight from that enum, so no priorityCode string
// ever reaches this field. toPickupRequestPriorityId converts the read-side priorityCode
// and is not applicable here.
export const toCreatePickupRequest = (
  values: PickupRequestFormValues,
  reasons: PickupRequestReasonsSelection
): CreatePickupRequest => ({
  sourceCompanyId: values.collectorId,
  targetCompanyId: values.haulerId,
  assignedCarrierId: values.carrierId,
  pickupDateFrom: values.pickupDateFrom as string,
  pickupDateTo: values.pickupDateTo,
  materials: values.materials,
  reasonIds: reasons.reasonIds,
  otherReasonText: reasons.otherReasonText.trim() || null,
  comment: values.comment || null,
  priority: values.priority as PickupRequestPriorityId,
  priorityReason: values.priorityReason || null,
  linkedTransactionNumber: null,
});

export const toFormValues = (
  request: PickupRequestDetails
): PickupRequestFormValues => ({
  collectorId: request.sourceCompanyId,
  haulerId: request.targetCompanyId,
  carrierId: request.assignedCarrierId,
  materials: request.materials.map(({ code, quantity }) => ({
    materialCode: code,
    quantity,
  })),
  pickupDateFrom: request.pickupDateFrom,
  pickupDateTo: request.pickupDateTo,
  comment: request.comment,
  priority: toPickupRequestPriorityId(request.priority) ?? null,
  priorityReason: request.priorityReason,
});

// SourceCompanyId is never included - it is locked in edit mode and UpdatePickupRequestDto
// has no field for it at all.
export const toUpdatePickupRequest = (
  values: PickupRequestFormValues,
  reasons: PickupRequestReasonsSelection
): UpdatePickupRequest => ({
  targetCompanyId: values.haulerId,
  assignedCarrierId: values.carrierId,
  materials: values.materials,
  pickupDateFrom: values.pickupDateFrom as string,
  pickupDateTo: values.pickupDateTo,
  reasonIds: reasons.reasonIds,
  otherReasonText: reasons.otherReasonText.trim() || null,
  comment: values.comment || null,
  priority: values.priority as PickupRequestPriorityId,
  priorityReason: values.priorityReason || null,
});
